import React, { useEffect, useState } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import DailyFloodReportStatusForm from "./DailyCloudBurstReportStatusForm";
import moment from "moment";
import DailyColdWaveReportStatusForm from "./DailyCloudBurstReportStatusForm";
import DailyCloudBurstReportStatusForm from "./DailyCloudBurstReportStatusForm";
import "../ReportEnhanced.css";
//import DMSHeader from "../../DMSHeader/DMSHeader";

const DailyCloudBurstReportStatus = () => {
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  useEffect(() => {
    GridStack.init();
  }, []);
  const coldWaveReportStatusfile = `DailyColdWaveReportStatus_${selectedDate}`;
  console.log("filename in reprotstatus=====", coldWaveReportStatusfile);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title="Cloud Burst Daily Report Status"
          fileName={`DailyCloudBurstReportStatus`}
          increaseHeaderHeight={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 10,
      id: 2,
      component: (
        <DailyCloudBurstReportStatusForm
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      ),
    },
  ];

  return (
    <div className="report-enhanced-wrapper">
      <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
        <GridItem layoutData={layoutData} />
      </div>
    </div>
  );
};

export default DailyCloudBurstReportStatus;
